import Failure from '../../../core/Failure';
import { ISmallUser } from '@leedpulse-monorepo/interfaces';
import { Authentication } from '@leedpulse-monorepo/classes';
import getUsersByConstraints from '../users/getUsersByConstraints';
export interface UserPartner {
  first_name: string;
  last_name: string;
  user_uuid: string;
  user_id: string;
}

async function getPartnerUserUuids(
  idSubscription: string,
  auth: Authentication
): Promise<ISmallUser[]> {
  try {
    const lpUsers = await getUsersByConstraints([
      {
        field: `id_subscription.${idSubscription}`,
        op: 'orderBy',
        value: "asc",
      },
    ]);

    const aSales = lpUsers.map((lpUser) => lpUser.toPatch() as unknown as ISmallUser);

    return aSales;
  } catch (e) {
    console.log('error: ', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new GetPartnerUserUuidsFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new GetPartnerUserUuidsFailure(e.message);
    }
    throw new GetPartnerUserUuidsFailure('Unknown error');
  }
}

export class GetPartnerUserUuidsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getPartnerUserUuids;
